"use client";
const e = () => {
  document.querySelector("html").style.overflow = "hidden", document.querySelector("body").style.overflow = "hidden";
}, o = () => {
  document.querySelector("html").style.overflow = "auto", document.querySelector("body").style.overflow = "auto";
};
export {
  e as setBodyFixed,
  o as setBodyScroll
};
